import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import './assets/main.css';

// IMPORTI ZA TOKEN SISTEM
import { initializeInterceptors } from './services/api';
import { TokenService } from './services/tokenService';
import TokenWatcher from './services/tokenWatcher';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Debug helpers za development
if (process.env.NODE_ENV === 'development') {
  import('./utils/debugHelpers');
  (window as any).__VUE_STORE__ = store;
  console.log(
    '🔧 Debug mode enabled - store available as window.__VUE_STORE__'
  );
}

const app = createApp(App);

app.use(store);
app.use(router);

// INITIALIZE TOKEN SISTEM
initializeInterceptors(store, router);

// Check if user is already logged in
const token = TokenService.getAccessToken();
if (token && !TokenService.isTokenExpired(token)) {
  TokenWatcher.getInstance().startWatching();
  store.dispatch('auth/fetchCurrentUser').catch(() => {
    TokenService.clearAll();
  });
}

app.mount('#app');
